import React from 'react';
import './style.css';
import { useCart } from '../../CartContext';

const ContadorCardapio = ({ quantidade, onQuantidadeChange }) => {
  const { addItemToCart, removeItemFromCart } = useCart();

  const handleIncrement = () => {
    onQuantidadeChange(quantidade + 1);
    addItemToCart(1); // atualiza o total global
  };

  const handleDecrement = () => {
    if (quantidade > 1) {
      onQuantidadeChange(quantidade - 1);
      removeItemFromCart(1); // atualiza o total global
    }
  };

  return (
    <div className="container-counter">
      <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
        <button className="btn-counter-remove" onClick={handleDecrement}>
          -
        </button>
        <div>{quantidade}</div>
        <button className="btn-counter-add" onClick={handleIncrement}>
          +
        </button>
      </div>
    </div>
  );
};

export default ContadorCardapio;
